export default {
	unexpectedError: (payload) => {
		if (payload.code === "unexpectedError") {
			console.error("Chamaileon unexpected error", payload);
			return false;
		}
	},
};
